import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { selectIsMember, useAuthStore } from '@/stores/useAuthStore';
import { buildPath, PAGE_PATHS } from '../const';

/** 회원 전용 화면. 비로그인이면 로그인(C-05)으로 보내고 돌아올 경로를 남긴다. */
export default function RequireMember({ children }: { children: ReactNode }) {
  const isMember = useAuthStore(selectIsMember);
  const location = useLocation();

  if (!isMember) {
    const redirect = encodeURIComponent(
      `${location.pathname}${location.search}`,
    );
    return (
      <Navigate
        to={`${buildPath(PAGE_PATHS.AUTH, { step: 'sign-in' })}?redirect=${redirect}`}
        replace
      />
    );
  }
  return children;
}
